import EducationContainer from './education_container';

const Education = EducationContainer;
export default Education;
